import { useEffect } from "react";
import { Card } from "@insights/ui";
import { useNavigate, useSearchParams } from "react-router";
import { PageHeader } from "../../../shared/components";
import {
  AppShell,
  buildDefaultWorkspacePath,
} from "../../../shared/layout";
import { useCheckoutStatus } from "../hooks/useWorkspaceCreation";

export function CheckoutCompletePage() {
  const navigate = useNavigate();
  const [parameters] = useSearchParams();
  const sessionId = parameters.get("checkout_session_id");
  const checkout = useCheckoutStatus(sessionId);

  useEffect(() => {
    if (checkout.data?.status === "completed" && checkout.data.workspaceId) {
      navigate(buildDefaultWorkspacePath(checkout.data.workspaceId), {
        replace: true,
      });
    }
  }, [checkout.data, navigate]);

  return (
    <AppShell>
      <PageHeader eyebrow="Stripe checkout" title="Creating your workspace" />
      <Card className="form-card workspace-create-card">
        {!sessionId && <p className="error">Checkout session is missing.</p>}
        {sessionId && checkout.isLoading && <p>Confirming your subscription…</p>}
        {checkout.data?.status === "pending" && (
          <p>Payment is confirmed. The workspace is being provisioned…</p>
        )}
        {checkout.data && ["failed", "expired"].includes(checkout.data.status) && (
          <p className="error">
            Checkout {checkout.data.status}. Return to workspace creation and try
            again.
          </p>
        )}
        {checkout.error && <p className="error">{checkout.error.message}</p>}
      </Card>
    </AppShell>
  );
}
